export const PHONE_BONUS_DEVICE_BLOCKED_REASON = "device_bonus_already_claimed";

export const PHONE_BONUS_DEVICE_BLOCKED_MESSAGE =
  "$5 Freeplay was already claimed from this device, so you can't get it again on this device.";

export function isPhoneBonusDeviceBlocked(value) {
  return value?.bonus_blocked_reason === PHONE_BONUS_DEVICE_BLOCKED_REASON;
}

export function showPhoneBonusResultToast(toast, value) {
  if (isPhoneBonusDeviceBlocked(value)) {
    toast.warning(PHONE_BONUS_DEVICE_BLOCKED_MESSAGE, { duration: 7000 });
    return;
  }
  if (Number(value?.free_play_credited || 0) > 0) {
    toast.success("$5 Freeplay added");
    return;
  }
  toast.success("Phone verified");
}
